import { render, staticRenderFns } from "./ButtonAdminPanel.vue?vue&type=template&id=9da89ec2&scoped=true"
import script from "./ButtonAdminPanel.vue?vue&type=script&lang=js"
export * from "./ButtonAdminPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonAdminPanel.vue?vue&type=style&index=0&id=9da89ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da89ec2",
  null
  
)

export default component.exports